// Has all reports API
import axios from 'axios';
export async function fetchReportData(connectionURl, start, end) {
  try {
    const response = await axios.get(`${connectionURl}/reports/activityReports/${start}&${end}`);

    const reportArray = response.data.map((item) => ({
      Ticket: item.Ticket,
      SectionName: item.SectionName,
      LaneNum: item.LaneNum,
      SpaceNum: item.SpaceNum,
      DateTimeIn: item.DateTimeIn,
      DateTimeOut: item.DateTimeOut,
      CarMake: item.CarMake,
      CarColor: item.CarColor,
      LicensePlate: item.LicensePlate,
    }));
    return reportArray;
  } catch (error) {
    console.error('Error fetching report data:', error);
  }
}

// Fetch activity report data for a given date range grouped by hour
export async function fetchActivityByHours(connectionURL, start, end) {
  try {
    const response = await axios.get(`${connectionURL}/reports/activitiesCountByHour/${start}&${end}`);
    if (response.data) {
      console.log(response.data, 'response data');
      return response.data;
    } else {
      console.log('No data found for the given date range');
    }
  } catch (error) {
    console.error('Error fetching activity by hours:', error);
  }
}

export async function fetchStayDurationReport(connectionURL, start, end) {
  try {
    const response = await axios.get(`${connectionURL}/reports/stayDurationStats/${start}&${end}`);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching stay duration report data:', error);
  }
}

// Function to pull open tickets data
export async function fetchOpenTickets(connectionURL, start, end) {
  try {
    const response = await axios.get(`${connectionURL}/reports/openTicketsReport/${start}&${end}`);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching open tickets data:', error);
  }
}

// Function that list lists the wait time in hours and minutes based on a date range
export async function listWaitTimeStats(connectionURL, start, end) {
  try {
    const result = await axios.get(`${connectionURL}/checkOuts/waitTimeList/${start}&${end}`);
    if (result) {
      return result.data;
    }
  } catch (err) {
    console.error('Error fetching wait time stats', err);
  }
}

// Function to pull closed tickets data
export async function fetchClosedTickets(connectionURL, start, end) {
  try {
    const response = await axios.get(`${connectionURL}/reports/closedTicketsReport/${start}&${end}`);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching closed tickets data:', error);
  }
}

// Make API call to fetch in tickets data
export async function fetchInTicketsData(connectionURL, start, end) {
  // Implementation for fetching data goes here
  try {
    const response = await axios.get(`${connectionURL}/reports/inTicketsReport/${start}&${end}`);
    console.log('In Tickets Response:', response);
    if (response.data && response.data.length > 0) {
      // Process and set the fetched data
      const inTicketsData = response.data.map((item) => ({
        inTickets: item.inTickets,
        DateIn: item.DateIn,
        HourIn: item.HourIn,
      }));
      console.log('In Tickets Data:', inTicketsData);
      return inTicketsData;
    } else {
      console.log('No data found');
    }
  } catch (error) {
    console.error('Error fetching in tickets data:', error);
  }
}

// Function that lists the manually closed tickets that were not checked out
export async function fetchManuallyClosedTicket(connectionURL, start, end) {
  try {
    const response = await axios.get(`${connectionURL}/reports/manuallyClosedTicketsList/${start}&${end}`);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.log('Error fetching manually closed tickets data:', error);
  }
}

// Function that lists the omitted tickets or tickets that were not checked in
export async function fetchOmittedTickets(connectionURL, start, end) {
  try {
    const response = await axios.get(`${connectionURL}/reports/omittedTicketsList/${start}&${end}`);
    if (response.data) {
      console.log('list of omitted tickets', response.data);
      return response.data;
    } else {
      console.log('no data');
    }
  } catch (error) {
    console.log('Error fetching omitted tickets data:', error);
  }
}

//Report that shows the total tickets issued grouped by date
export async function fetchTotalInTicketsByDate(connectionURL, start, end) {
  console.log('Fetching total in tickets by date from', start, end);
  try {
    const response = await axios.get(`${connectionURL}/reports/totalInTicketsByDate/${start}&${end}`);
    if (response.data) {
      console.log(response.data, 'Total in tickets by date');
      return response.data[0].ticketsIssued;
    }
  } catch (error) {
    console.error('Error fetching total in tickets by date:', error);
  }
}

// Report that fetches closed tickets data for a given date range
export async function fetchClosedTicketsData(connectionURL, start, end) {
  try {
    const response = await axios.get(`${connectionURL}/reports/closedTicketsReportByDate/${start}&${end}`);
    if (response.data) {
      return response.data;
    }
  } catch (error) {
    console.error('Error fetching closed tickets data:', error);
  }
}

// Report that shows the total closed tickets grouped by date
export async function fetchTotalClosedTicketsByDate(connectionURL, start, end) {
  console.log('Fetching total closed tickets by date from', start, end);
  try {
    const response = await axios.get(`${connectionURL}/reports/totalClosedTicketsByDate/${start}&${end}`);
    if (response.data) {
      // setReportData(response.data);
      return Number(response.data[0].closedTickets);
    }
  } catch (error) {
    console.error('Error fetching total closed tickets by date:', error);
  }
}

// Search page
export async function fetchSearchResults(connectionUR, item) {
  try {
    // Implement actual API call logic here
    const response = await axios.get(`${connectionUR}/search/searchRecords/${item}`);
    console.log(!Array.isArray(response.data, 'Is Array before checking'));
    // If API returns nothing, return empty array
    if (!Array.isArray(response.data || response.data.length === 0)) {
      console.log(Array.isArray(response.data, 'Is Array'));
      return [];
    }
    // Handle successful response
    return response.data;
  } catch (error) {
    // This returns an empty array if no results were found. It is important because without
    // an empty array returned, React does not display anything. See the component code
    if (error.response?.status === 404) {
      console.warn('No records found for search');
      return []; // treat as "no data"
    }
    console.error('Error fetching search results:', error);
  }
}
